/**
 * Text Block Renderer
 * Renders markdown content using the existing Response component
 */

import React from "react";
import { Response } from "@strivelabs/ui-blocks";
import type { UIBlock } from "@/types/ui-blocks";

export interface TextBlockRendererProps {
  block: UIBlock;
}

export function TextBlockRenderer({ block }: TextBlockRendererProps) {
  if (block.type !== 'text') return null;
  return <Response>{block.content}</Response>;
}
